import {app} from "../../config/constants"
import * as companiesActions from './actions'
import {store} from "../../reducers"

export const write = (company) => {
	return new Promise((resolve, reject) => {
		// Get Company from DB

		app.database().ref('/cams/companies').orderByChild('wordpressId').equalTo(company.wordpressId).once('value', (companies) => {
			if (null === companies.val()) {
				app.database().ref('/cams/companies').push(company).then(companySnap => {
					resolve();
				});
			} else {
				companies.forEach((companySnap) => {
					resolve();
					app.database().ref('/cams/companies').child(companySnap.key).set(company).then(companySnap => {
						resolve();
					});
				});
			}
		});
	});
};

export const loadCompanies = () => {
	const ref = app.database().ref('/cams/companies');

	new Promise( ( resolve, reject ) => {
		ref.orderByChild( 'title' ).once('value', (companies) => {
			store.dispatch(companiesActions.addCompanies(companies));
		});
	});
};


// WEBPACK FOOTER //
// ./src/api/companies/index.js